import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IWordExamVm } from '../word-exam-vm.model';
import { IWordExamModifiedDateIm } from '../word-exam-modified-date-im.model';
@Injectable({ providedIn: 'root' })
export class WordExamModifiedDateService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/WordExamModifiedDate`;
  }
  post(wordExamModifiedDateIm: IWordExamModifiedDateIm): Observable<IWordExamVm> {
    const headers = this.createHeaders();
    return this.http.post<IWordExamVm>(this.baseUrl, wordExamModifiedDateIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
